import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Protect } from '@clerk/clerk-react';

import LocalAdsChecker from '@components/LocalAdsChecker';

import { IndustryInsightsPage } from '../reports/IndustryInsights';

import AccessDenied from '../errors/AccessDenied';

import BusinessProfile from './BusinessProfile';
import ClicksToSales from './ClicksToSales';
import LocalAds from './LocalAds';
import LocalListingsChain from './LocalListingsChain';
import LocalAdsChain from './LocalAdsChain';
import Overview from './Overview';
import ProductLocator from './ProductLocator';
import SWIS from './SWIS';

export const InsightsLayout = () => {
	return (
		<Protect permission="org:insights:read" fallback={<AccessDenied />}>
			<Outlet />
		</Protect>
	);
};

export const insightsRoutes = [
	// chain
	{ path: 'local-listings', element: <LocalListingsChain /> },
	{ path: 'local-ads', element: <LocalAdsChain /> },
	// both
	{
		path: ':shopId?',
		children: [
			{ path: 'overview', element: <Overview /> },
			{ path: 'product-locator', element: <ProductLocator /> },
			{ path: 'business-profile', element: <BusinessProfile /> },
			{ index: true, element: <Navigate to="overview" replace /> }
		]
	},
	// shop only
	{
		path: ':shopId',
		children: [
			{ path: 'industry', element: <IndustryInsightsPage /> },
			{ path: 'google-swis', element: <Navigate to="local-listings" replace /> },
			{ path: 'local-listings', element: <SWIS /> },
			{
				path: 'local-ads',
				element: (
					<LocalAdsChecker>
						<LocalAds />
					</LocalAdsChecker>
				)
			},
			{
				path: 'clicks-to-sales',
				element: (
					<LocalAdsChecker>
						<ClicksToSales />
					</LocalAdsChecker>
				)
			}
		]
	}
];
